import { Typography } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";

import HNSColors from "../../../../../ui library/HNSColors";
import CheckBox from "../../../provider-management/components/fields/CheckBox";

import {
  getServiceCode,
  getServiceDescription,
  getServiceName,
} from "./servicesUtils";

export default function ServiceRow({ checked, data, onToggle, readOnly, showAddedTag }) {
  return (
    <CheckBox
      checked={checked}
      handleClick={(nextChecked) => onToggle(nextChecked, data)}
      readOnly={readOnly}
      label={
        <div>
          <Typography
            className="text-[14px] font-semibold"
            sx={{ color: readOnly ? HNSColors.neutrals[400] : HNSColors.neutrals[100] }}
          >
            {getServiceCode(data)} | {getServiceName(data)}
            {showAddedTag ? (
              <span style={{ marginLeft: 6, color: HNSColors.neutrals[500], fontWeight: 400, fontSize: "10px" }}>
                (Added)
              </span>
            ) : null}
          </Typography>
          <Typography className="text-[14px] font-normal" sx={{ color: HNSColors.neutrals[500] }}>
            {getServiceDescription(data)}
          </Typography>
        </div>
      }
    />
  );
}

ServiceRow.propTypes = {
  checked: PropTypes.bool.isRequired,
  data: PropTypes.object.isRequired,
  onToggle: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  showAddedTag: PropTypes.bool,
};

ServiceRow.defaultProps = {
  readOnly: false,
  showAddedTag: false,
};
